
import { request } from './';

const broadcast = async (title, message) => {
    const fetchResult = await request('/notifications/broadcast', { title, message });
    return fetchResult.data;
};

export default { broadcast };
